import styled from "styled-components";

import { ReactComponent as HeraldicPeopleErrorSVG } from "../assets/heraldic-people-error.svg";

export const ErrorSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  > div {
    display: flex;
    justify-content: space-between;
    width: 1150px;
    margin-bottom: clamp(4.2rem, 8vh, 6rem);
    font-size: .8rem;

    @media (min-width: 1800px) {
      width: 1300px;
    }
    @media (max-width: 1200px) {
      width: 100%;
      padding: 0 2rem;
    }

    > span {
      width: 45%;
    }

    > div {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 50%;

      h1 {
        margin: 0 0 1.2rem 0;
        font-size: 2.2rem;
        width: 100%;
        white-space: nowrap;

        span {
          color: ${(props) => props.theme.primaryYellow};
        }
      }

      u {
        font-weight: bold;
        color: ${(props) => props.theme.primaryPurple};
      }
      u:hover {
        cursor: pointer;
      }
    }
  }
`;

export const HeraldicPeopleError = styled(HeraldicPeopleErrorSVG)`
  width: 100%;
  height: auto;
`;
